import { render, staticRenderFns } from "./SfDivider.vue?vue&type=template&id=2431284b&functional=true&"
import script from "./SfDivider.vue?vue&type=script&lang=js&"
export * from "./SfDivider.vue?vue&type=script&lang=js&"
import style0 from "./SfDivider.vue?vue&type=style&index=0&id=2431284b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports